export async function loadInputMask() {
  const { InputMask } = await import('./InputMask');
  return InputMask;
}
